module.exports = __webpack_public_path__ + "static/zuri-11m-flight-demonstrator-proof-of-concept-early-vtol-test-7dbe547ad96446f109e13e1b1b311385.mp4";